import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Users from 'Components/UsersView/users';
import ProtocolRecords from 'Components/ProtocolView/protocolRecords';
import LeftPanel from 'Components/LeftPanel/leftPanel';
import SmrHeader from 'Components/smrHeader';
import SmrFooter from 'Components/smrFooter';
import UserSettings from 'Components/UserSettings/userSettings';
import OtherSettings from 'Components/OtherSettings/otherSettings';
import DocumentHistory from 'Components/DocumentHistory/documentHistory';
import ConverterSettings from 'Components/ConverterSettings/converterSettings';
import IntegrationSettings from 'Components/IntegrationSettings/IntegrationSettings';
import StopList from 'Components/StopList/stopList';
import Migration from 'Components/Migration/migration'
import 'Styles/main.scss';
import 'Styles/commonElements.scss';
import 'Styles/commonComponents.scss';
import AppStore from 'Stores/AppStore';
import { observer } from 'mobx-react';
import NotFoundPage from "Components/notFoundPage";
import Traces from "Components/Traces/traces";
import Stats from "Components/Stats/Stats";
import UsersMetrics from "Components/Metrics/UsersMetrics";
import UserMetrics from "Components/Metrics/UserMetrics";
import queryString from "query-string";
import MkMessaging from "Components/MkMessaging/mkMessaging";
import DeveloperSettings from "Components/DeveloperSettings/DeveloperSettings";
import ModalWindow from "Components/Common/modalWindow";
import MigrationStore from 'Stores/migrationStore';
import DocumentReload from 'Components/DocumentReload/documentReload';
import Enumerable from "linq";
import Helper from 'Utils/Helper';
import UsersServerSettings from 'Components/UsersServerSettings/UsersServerSettings';
import DeviceTraces from 'Components/DeviceTraces/deviceTraces';

class App extends React.Component {
    constructor() {
        super();

        this.state = {
            alert: {
                show: false,
                type: '',
                text: ''
            }
        };
    }

    componentDidMount() {
        window.onkeydown = function (event) {
            if (event.code === "Space" &&
                document.activeElement.tagName.toLowerCase() === 'button') {
                event.preventDefault();
            }
        };
    }

    RenderModal(props) {
        if (AppStore.modalSettings)
            return (
                <ModalWindow
                    {...props}
                    {...AppStore.modalSettings}
                    close={AppStore.CloseModal.bind(AppStore)}
                />
            )
    }

    render() {
        let element;
        if (AppStore.loading)
            element = <LoadView loading={true} />;

        if (AppStore.smrWorkState.doesSmrWork === false) {
            element = <Navigate to={`${window.SmrLocation}/error`} />
        } else if (!AppStore.loggedIn) {
            let pageTitle = window.location.pathname;
            pageTitle = Helper.RemovePrefix(pageTitle, `${window.SmrLocation}`);
            pageTitle = Helper.RemovePrefix(pageTitle, '/');

            AppStore.SetLastPageInfo({
                pageTitle: pageTitle,
                params: queryString.parse(window.location.search),
                hash: window.location.hash
            });

            element = <Navigate to={`${window.SmrLocation}/login`} />;
        }

        var migrationNeeded = MigrationStore.migration.migrationNeeded;
        var migrationInProcess = MigrationStore.migration.migrationInProcess;

        if (element == null) {

            var routesForCheckVisibility = [
                <Route path={'/users'}
                    element={<Users
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/users/serversettings'}
                    element={<UsersServerSettings />} />
                ,
                <Route path={'/users/deviceTrace'}
                    element={<DeviceTraces />} />
                ,
                <Route path={'/userSettings'}
                    element={<UserSettings
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/integrationService'}
                    element={<IntegrationSettings
                        location={window.location}
                        migrationInProcess={migrationInProcess} />} />
                ,
                <Route path={'/converter'}
                    element={<ConverterSettings
                        location={window.location}
                        migrationInProcess={migrationInProcess} />} />
                ,
                <Route path={`/otherSettings`}
                    element={<OtherSettings
                        location={window.location}
                        migrationInProcess={migrationNeeded} />} />
                ,
                <Route path={'/stopList'}
                    element={<StopList
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/protocolRecords'}
                    element={<ProtocolRecords
                        location={window.location}
                        migrationInProcess={migrationInProcess} />} />
                ,
                <Route path={'/documentHistory'}
                    element={<DocumentHistory
                        location={window.location}
                        migrationInProcess={migrationNeeded} />} />
                ,
                <Route path={'/documentReload'}
                    element={<DocumentReload
                        location={window.location}
                        migrationInProcess={migrationNeeded} />} />
                ,
                <Route path={'/traces'}
                    element={<Traces
                        location={window.location} />} />
                ,
                <Route path={'/stats'}
                    element={<Stats
                        location={window.location} />} />
                ,
                <Route path={'/usersMetrics'}
                    element={<UsersMetrics
                        location={window.location} />} />
                ,
                <Route path={'/userMetrics'}
                    element={<UserMetrics
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/mkMessaging/*'}
                    element={<MkMessaging
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/dev'}
                    element={<DeveloperSettings
                        location={window.location} />} />
            ];

            var routesOther = [
                <Route path={'/migration'}
                    element={<Migration
                        location={window.location}
                        migrationNeeded={migrationNeeded} />} />
                ,
                <Route path={'/404'}
                    element={<NotFoundPage />} />
                ,
                <Route path={'/login'}
                    element={<Navigate to={`${window.SmrLocation}/users`} />} />
                ,
                <Route path={'/'}
                    element={<Navigate to={`${window.SmrLocation}/users`} />} />
                ,
                <Route path={'*'}
                    element={<NotFoundPage />} />
            ];

            var filterAvailablePagesForCurrentUser = AppStore.filterAvailablePagesForCurrentUser;
            var filterAvailablePagesForCurrentUserEnumerable = Enumerable.from(filterAvailablePagesForCurrentUser);
            var filterMainMenuItemsNamesVisible = AppStore.productModeSettings?.filterMainMenuItemsNamesVisible;
            var filterMainMenuItemsNamesVisibleEnumerable = Enumerable.from(filterMainMenuItemsNamesVisible);
            var routes =
                Enumerable
                    .from(routesForCheckVisibility)
                    .where(route => {
                        var pathName = route.props.path.split('/')[1];
                        var isVisible = filterMainMenuItemsNamesVisible == null || filterMainMenuItemsNamesVisibleEnumerable.any(it => it == pathName);
                        return isVisible;
                    })
                    .concat(routesOther)
                    .toArray()
                ;

            var pageName = window.location.pathname.replace(window.SmrLocation + '/', '').split('/')[0];
            var isAvailable =
                filterAvailablePagesForCurrentUser == null // обход ошибок до получения данных с backend
                ||
                filterAvailablePagesForCurrentUserEnumerable.any(it => it == pageName);
            var routesPathPageNames =
                Enumerable
                    .from(routes)
                    .select(
                        route => {
                            let routePathPageName = route.props.path.substring(1).split('/')[0];
                            return routePathPageName;
                        })
                    .toArray();
            var firstAvailableRoutePageName =
                Enumerable
                    .from(routesPathPageNames)
                    .where(
                        routePathPageName => {
                            let routeIsAvailable = filterAvailablePagesForCurrentUser
                                ? filterAvailablePagesForCurrentUserEnumerable.any(it => it == routePathPageName)
                                : true;
                            return routeIsAvailable;
                        })
                    .firstOrDefault(it => it, null);
            var pageNameContainsInRoutes = Enumerable.from(routesPathPageNames).any(routePathPageName => routePathPageName == pageName); // для проверки ошибок обрыва соединения с backend
            if (pageNameContainsInRoutes == false) {
                firstAvailableRoutePageName = "404";
            }
            var firstAvailableRouteRelative = firstAvailableRoutePageName ? `${window.SmrLocation}/${firstAvailableRoutePageName}` : null;
            var firstAvailableRouteAbsolute = firstAvailableRouteRelative ? (window.location.origin + firstAvailableRouteRelative) : null;

            if (element == null
                &&
                isAvailable == false
            ) {
                element = (
                    <Navigate to={firstAvailableRouteRelative} />
                ); // не обновляет полностью страницу
                window.location = firstAvailableRouteAbsolute;
            }

            // todo: автоматическая высота data-container по количеству контролов в LeftPanel

            if (element == null) {
                element = (
                    <div className="main-container">
                        <div className="filler" />
                        <div className="app-container">
                            <SmrHeader />
                            <div className="data-container">
                                <LeftPanel />
                                <div className={"main-content " + (isAvailable ? "" : "not-available")}>
                                    <Routes>
                                        {routes.map(route => (
                                            <Route {...route.props}
                                                key={"key_route_" + route.props.path} />
                                        ))}
                                    </Routes>
                                    {this.RenderModal()}
                                </div>
                            </div>
                            <SmrFooter smrVersion={AppStore.smrVersion} />
                        </div>
                        <div className="filler" />
                    </div>
                );
            }

        }

        return element;
    }
}

export default observer(App);